export const heroImages = {
  heroBackground: "https://readdy.ai/api/search-image?query=Active%20senior%20couple%20walking%20in%20nature%20on%20sunny%20day%2C%20mountain%20trail%2C%20healthy%20lifestyle%2C%20warm%20golden%20light%2C%20editorial%20photography%2C%20soft%20focus%20background%2C%20natural%20warm%20tones&width=1600&height=900&seq=hero-joint-genesis&orientation=landscape",
};

export const lifestyleImages = {
  stayActive: "https://readdy.ai/api/search-image?query=Senior%20woman%20practicing%20yoga%20outdoors%20in%20garden%2C%20morning%20sunlight%2C%20peaceful%20smile%2C%20healthy%20aging%2C%20warm%20neutral%20tones%2C%20editorial%20lifestyle%20photography%2C%20soft%20natural%20lighting&width=800&height=1000&seq=lifestyle-active&orientation=portrait",
  familyTime: "https://readdy.ai/api/search-image?query=Happy%20grandparents%20playing%20with%20grandchildren%20in%20backyard%2C%20laughing%20together%2C%20warm%20afternoon%20light%2C%20family%20bonding%2C%20editorial%20lifestyle%20photography%2C%20soft%20natural%20tones&width=800&height=1000&seq=lifestyle-family&orientation=portrait",
  independence: "https://readdy.ai/api/search-image?query=Confident%20senior%20man%20gardening%20in%20home%20garden%2C%20active%20independent%20lifestyle%2C%20morning%20sunlight%2C%20warm%20tones%2C%20editorial%20photography%2C%20natural%20soft%20lighting&width=800&height=1000&seq=lifestyle-independence&orientation=portrait",
  enjoyTravel: "https://readdy.ai/api/search-image?query=Senior%20couple%20exploring%20European%20city%20street%2C%20walking%20hand%20in%20hand%2C%20golden%20hour%20light%2C%20travel%20adventure%2C%20editorial%20lifestyle%20photography%2C%20warm%20natural%20tones&width=800&height=1000&seq=lifestyle-travel&orientation=portrait",
};

export const ingredientImages = {
  mobilee: "https://readdy.ai/api/search-image?query=Hyaluronic%20acid%20molecular%20structure%20concept%20art%2C%20abstract%20organic%20shapes%2C%20soft%20white%20and%20gold%20tones%2C%20clean%20medical%20editorial%20style%2C%20minimalist%20composition&width=400&height=400&seq=ingredient-mobilee&orientation=squarish",
  ginger: "https://readdy.ai/api/search-image?query=Fresh%20ginger%20root%20sliced%20on%20white%20surface%2C%20macro%20photography%2C%20warm%20golden%20tones%2C%20clean%20editorial%20food%20photography%20style%2C%20soft%20natural%20lighting&width=400&height=400&seq=ingredient-ginger&orientation=squarish",
  boswellia: "https://readdy.ai/api/search-image?query=Boswellia%20serrata%20resin%20and%20dried%20herb%20on%20white%20surface%2C%20macro%20photography%2C%20warm%20amber%20tones%2C%20clean%20editorial%20botanical%20style%2C%20soft%20lighting&width=400&height=400&seq=ingredient-boswellia&orientation=squarish",
  pineBark: "https://readdy.ai/api/search-image?query=Pine%20bark%20extract%20powder%20in%20small%20glass%20dish%2C%20white%20background%2C%20macro%20photography%2C%20warm%20neutral%20tones%2C%20clean%20medical%20editorial%20style%2C%20soft%20lighting&width=400&height=400&seq=ingredient-pine&orientation=squarish",
  bioperine: "https://readdy.ai/api/search-image?query=Black%20pepper%20corns%20macro%20close-up%20on%20white%20surface%2C%20high%20detail%20texture%2C%20warm%20dark%20tones%2C%20clean%20editorial%20food%20photography%20style%2C%20soft%20lighting&width=400&height=400&seq=ingredient-bioperine&orientation=squarish",
};

export const productImage = "https://public.readdy.ai/ai/img_res/503ab2e4-9c3f-4618-be48-b0029aa560e7.png";

export const ingredientData = [
  {
    id: "mobilee",
    name: "Mobilee",
    subtitle: "Patented Hyaluronic-Acid Complex",
    benefit: "Supports Joint Lubrication",
    description: "A patented hyaluronic-acid complex studied for synovial fluid quality.",
    image: ingredientImages.mobilee,
  },
  {
    id: "ginger",
    name: "Ginger Root",
    subtitle: "Traditional Botanical Extract",
    benefit: "Supports Healthy Movement",
    description: "A culinary and herbal staple rich in plant compounds.",
    image: ingredientImages.ginger,
  },
  {
    id: "boswellia",
    name: "Boswellia Serrata",
    subtitle: "Traditional Resin Extract",
    benefit: "Supports Joint Comfort",
    description: "Long studied for joint comfort and everyday mobility.",
    image: ingredientImages.boswellia,
  },
  {
    id: "pineBark",
    name: "French Maritime Pine Bark",
    subtitle: "Polyphenol-Rich Extract",
    benefit: "Antioxidant Support",
    description: "Rich in polyphenols that contribute to antioxidant intake.",
    image: ingredientImages.pineBark,
  },
  {
    id: "bioperine",
    name: "BioPerine",
    subtitle: "Black Pepper Extract",
    benefit: "Enhanced Absorption",
    description: "A black-pepper extract included to support nutrient uptake.",
    image: ingredientImages.bioperine,
  },
];

export const faqData = [
  {
    question: "How do I take Joint Genesis?",
    answer: "Joint Genesis is a once-daily formula. Simply take one capsule each day with a glass of water, preferably with a meal for optimal absorption. Consistency is key — make it part of your daily routine.",
  },
  {
    question: "Is it suitable for men and women?",
    answer: "Yes, Joint Genesis is formulated for both men and women who want to support their joint health, mobility, and comfort. The ingredients are carefully selected to benefit adults of all genders.",
  },
  {
    question: "What ingredients are included?",
    answer: "Joint Genesis contains five studied ingredients: Mobilee (a patented hyaluronic-acid complex), Ginger Root, Boswellia Serrata, French Maritime Pine Bark, and BioPerine (black pepper extract for enhanced absorption).",
  },
  {
    question: "What is the guarantee policy?",
    answer: "Every order of Joint Genesis is backed by a 180-day, 100% money-back guarantee. If you are not completely satisfied for any reason, simply request a refund directly through the official source within six full months.",
  },
  {
    question: "Where can I find current pricing?",
    answer: "Current pricing and special offers are available exclusively on the official Joint Genesis website. Visit the official source to review the latest packages and availability.",
  },
  {
    question: "How long does one bottle last?",
    answer: "Each bottle of Joint Genesis contains 30 capsules, providing a full 30-day supply when taken as directed (one capsule per day).",
  },
  {
    question: "Can I review the ingredient list before purchasing?",
    answer: "Absolutely. The full ingredient list and detailed supplement facts are available on the official Joint Genesis website. You can review every ingredient and its dosage before making your purchase.",
  },
  {
    question: "Where can I order safely?",
    answer: "The safest way to order Joint Genesis is directly through the official website. This ensures you receive the authentic product, full guarantee coverage, and access to any current promotions.",
  },
];

export const extraContent = `Understanding Joint Lubrication

As we age, synovial fluid — the natural lubricant inside your joints — begins to thin out and lose effectiveness. This is why stiffness, discomfort, and reduced mobility become common after 50. Joint Genesis was developed specifically to address this root cause. Its key ingredient, Mobilee, is a patented hyaluronic-acid complex clinically studied for supporting synovial fluid quality — targeting lubrication at the source, not just masking symptoms.

Why Ingredients Matter

Joint Genesis combines five carefully selected compounds, each with a specific role. Ginger Root and Boswellia Serrata are traditional botanicals with long histories of supporting healthy movement. French Maritime Pine Bark delivers antioxidant support through rich polyphenols. BioPerine enhances absorption so your body actually uses these nutrients. Together, they create comprehensive, daily nutritional support — not overnight miracles, but consistent help for the activities you love.

Improve Comfort, Increase Independence

Joint discomfort affects more than your body — it chips away at your independence, your mood, and your willingness to stay active. Joint Genesis was formulated to help you reclaim those moments. By supporting joint lubrication, flexibility, and everyday comfort, it helps you move with more confidence. One capsule a day fits easily into any routine, and the 180-day guarantee gives you six full months to evaluate the results.`;

export const lifestyleDescriptions = {
  stayActive: {
    title: "Stay Active",
    description: "Imagine waking up excited for your morning walk, not dreading the stiffness in your knees. You lace up your shoes and head out the door, feeling the fresh air and knowing your joints are ready for the day. That is the freedom Joint Genesis helps support.",
  },
  familyTime: {
    title: "Spend Time With Family",
    description: "Picture yourself kneeling in the garden with your grandchildren, planting flowers and laughing together. No hesitation, no worry about whether you can get back up. Just pure, uninterrupted joy with the people you love most.",
  },
  independence: {
    title: "Maintain Independence",
    description: "Think about carrying your own groceries up the stairs, tending to your garden without help, and moving through your home with confidence. Independence is not about doing everything alone — it is about knowing you can when you want to.",
  },
  enjoyTravel: {
    title: "Enjoy Travel",
    description: "Envision exploring a new city, walking cobblestone streets, and discovering hidden cafes. You are not held back by discomfort or planning your day around rest stops. Every step is part of the adventure, not a limitation.",
  },
};

export const navLinks = [
  { label: "The Science", href: "#science" },
  { label: "Ingredients", href: "#ingredients" },
  { label: "FAQ", href: "#faq" },
];